import React from 'react';
import LandingPage from '../pages/LandingPage.jsx';

export default function LandingPageWrapper() {
  return <LandingPage />;
}
